var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sourceIsH5)?_c('NavBar',{attrs:{"narBarTitle":_vm.title}}):_vm._e(),_c('div',{staticClass:"infoCard"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.details)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }